import { createApi } from '@reduxjs/toolkit/query/react';
import { HttpMethod } from '@vision/ui/enums';
import { EmailCampaignListItem } from '@vision/ui/interfaces';
import { axiosBaseQuery } from './base.service';

interface EmailCampaignsRequest {
  accountId: string;
}

interface EmailCampaignsResponse {
  data: EmailCampaignListItem[];
}

export const CampaignService = createApi({
  reducerPath: 'CampaignService',
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    emailCampaigns: builder.query<EmailCampaignListItem[], EmailCampaignsRequest>({
      query: ({ accountId }) => ({
        url: '/v1/email_campaigns',
        method: HttpMethod.GET,
        params: {
          node_id: accountId,
        },
      }),
      transformResponse: (response: EmailCampaignsResponse) => (Array.isArray(response?.data) ? response.data : []),
    }),
  }),
});

export const { useEmailCampaignsQuery } = CampaignService;
